import { HttpContext } from '@angular/common/http';
import { IS_STOREFRONT_REQUEST } from '@prosell/feature-customer-auth/data-access/storefront-request.context';

/**
 * Marca una petición como propia de la superficie de la tienda (ver `IS_STOREFRONT_REQUEST`).
 * Única copia: `feature-storefront` y `feature-cart-checkout` la reexportan.
 * Función y no constante: `HttpContext` es mutable y compartirlo filtraría el estado de reintento entre peticiones.
 */
export function ctxTienda(): HttpContext {
  return new HttpContext().set(IS_STOREFRONT_REQUEST, true);
}
